import { makeAutoObservable } from 'mobx';

export class DropdownMenuState {
    public isOpen: boolean = false;

    public constructor() {
        makeAutoObservable(this);
    }

    public closeDropdownMenu = (): void => {
        this.isOpen = false;
    };

    public toggleDropdownMenu = (): void => {
        this.isOpen = !this.isOpen;
    };
}
